export default __webpack_public_path__ + "static/media/weather-app.60b74f2d.png";